<div class="container-fluid">
  <h4>{{'Search.header' | translate}}</h4>
  <div class="row mt-4">
    <div class="col-4">
      <form>
        <mat-form-field class="col-12">
          <mat-label>{{'Search.lblMarket' | translate}}</mat-label>
          <mat-select [(ngModel)]="search.marketId" [ngModelOptions]="{standalone: true}" required>
            @for (market of markets; track market) {
              <mat-option [value]="market.id">
                {{market.value}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="col-12">
          <mat-form-field class="col-6" style="padding-left: 0px;">
            <mat-label>{{'Search.lblDateFrom' | translate}}</mat-label>
            <input matInput [matDatepicker]="dp1" readonly [(ngModel)]="search.dateFrom"
              [ngModelOptions]="{standalone: true}">
              <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
              <mat-datepicker #dp1 disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-6" style="padding-right: 0px;">
              <mat-label>{{'Search.lblDateTo' | translate}}</mat-label>
              <input matInput [matDatepicker]="dp2" readonly [(ngModel)]="search.dateTo"
                [ngModelOptions]="{standalone: true}">
                <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                <mat-datepicker #dp2 disabled="false"></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12">
              <button mat-raised-button  color="primary" type="button" (click)="OnClickSearch()">{{'Search.btnSearch' | translate}}</button>
            </div>
          </form>
        </div>
      </div>
      <div class="mat-elevation-z8 mt-3 slider" [ngStyle]="{'display': isGeneratedSearch? 'block' : 'hidden'}" [@slider]="isGeneratedSearch? 'show' : null">
        <div class="scrollableTable">
          @if (isGeneratedSearch) {
            <div style="width: 100%;">
              <div style="float: right; margin: 10px;">
                <i style="font-size: 1.5em;" class="fa fa-file-excel-o clickable text-success"
                aria-hidden="true" (click)="OnClickExport()" title="Export to Excel"></i>
              </div>
            </div>
          }
          <table mat-table [dataSource]="dataSource" matSort matSortActive="Date" matSortDisableClear matSortDirection="desc">

            <ng-container matColumnDef="Description">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%; font-size: 16px;"> {{'Search.thDescription' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.description}}</td>
            </ng-container>

            <ng-container matColumnDef="Item">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%; font-size: 16px;"> {{'Search.thItem' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.item}}</td>
            </ng-container>

            <ng-container matColumnDef="Value">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%; font-size: 16px;"> {{'Search.thValue' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.value}}</td>
            </ng-container>

            <ng-container matColumnDef="Date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%; font-size: 16px;"> {{'Search.thDate' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.date}}</td>
            </ng-container>

            <ng-container matColumnDef="dateFilter">
              <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
                <input matInput [matDatepicker]="dpCol" readonly [(ngModel)]="search.dateFilter.filterValue"
                  [ngModelOptions]="{standalone: true}" (ngModelChange)="ApplyFilterOptions(false)" style="width: 60%; vertical-align: middle; height: 25px; border: 1px solid; border-radius: 5px;" >
                  <mat-datepicker-toggle [ngClass]="{'filterEnabled':search.dateFilter.filterEnabled === true }" matSuffix [for]="dpCol"></mat-datepicker-toggle>
                  <mat-datepicker #dpCol disabled="false">
                    <mat-datepicker-actions>
                      <button mat-raised-button color="warn" (click)="ResetDateFilter()" matDatepickerCancel>{{'btnReset' | translate}}</button>
                      <button mat-raised-button color="primary" matDatepickerApply>{{'btnApply' | translate}}</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </th>
              </ng-container>

              <ng-container matColumnDef="desFilter">
                <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
                  <input matInput [(ngModel)]="search.descriptionFilter.filterValue" [ngModelOptions]="{standalone: true}"
                    style="width: 60%; vertical-align: middle; height: 25px; border: 1px solid; border-radius: 5px;">
                    <mat-select class="triggerChange" [(ngModel)]="search.descriptionFilter.filterType" [ngModelOptions]="{standalone: true}" style="width: 30%;text-align: left;" (openedChange)="ApplyFilterOptions($event)">
                      <mat-select-trigger>
                        <mat-icon class="filterIcon" color="{{search.descriptionFilter.filterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                      </mat-select-trigger>
                      <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                      <mat-option value="temp">No Filter</mat-option>
                      <mat-option value="contains">Contains</mat-option>
                      <mat-option value="equals">Equals</mat-option>
                      <mat-option value="greaterThan">Greater Than</mat-option>
                      <mat-option value="lessThan">Less Than</mat-option>
                    </mat-select>
                  </th>
                </ng-container>

                <ng-container matColumnDef="itemFilter">
                  <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
                    <input matInput [(ngModel)]="search.itemFilter.filterValue" [ngModelOptions]="{standalone: true}"
                      style="width: 60%; vertical-align: middle; height: 25px; border: 1px solid; border-radius: 5px;">
                      <mat-select class="triggerChange" [(ngModel)]="search.itemFilter.filterType" [ngModelOptions]="{standalone: true}" style="width: 30%;text-align: left;" (openedChange)="ApplyFilterOptions($event)">
                        <mat-select-trigger>
                          <mat-icon class="filterIcon" color="{{search.itemFilter.filterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                        </mat-select-trigger>
                        <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                        <mat-option value="temp">No Filter</mat-option>
                        <mat-option value="contains">Contains</mat-option>
                        <mat-option value="equals">Equals</mat-option>
                        <mat-option value="greaterThan">Greater Than</mat-option>
                        <mat-option value="lessThan">Less Than</mat-option>
                      </mat-select>
                    </th>
                  </ng-container>

                  <ng-container matColumnDef="valueFilter">
                    <th mat-header-cell *matHeaderCellDef class="tableFilterFont">
                      <input matInput [(ngModel)]="search.valueFilter.filterValue" [ngModelOptions]="{standalone: true}"
                        style="width: 60%; vertical-align: middle; height: 25px; border: 1px solid; border-radius: 5px;">
                        <mat-select class="triggerChange" [(ngModel)]="search.valueFilter.filterType" [ngModelOptions]="{standalone: true}" style="width: 30%;text-align: left;" (openedChange)="ApplyFilterOptions($event)">
                          <mat-select-trigger>
                            <mat-icon class="filterIcon" color="{{search.valueFilter.filterEnabled ? 'primary': 'secondary'}}">filter_alt</mat-icon>
                          </mat-select-trigger>
                          <!-- <mat-option value="temp" style="visibility: hidden; height: 1px;">temp</mat-option> -->
                          <mat-option value="temp">No Filter</mat-option>
                          <mat-option value="contains">Contains</mat-option>
                          <mat-option value="equals">Equals</mat-option>
                          <mat-option value="greaterThan">Greater Than</mat-option>
                          <mat-option value="lessThan">Less Than</mat-option>
                        </mat-select>
                      </th>
                    </ng-container>

                    <ng-container matColumnDef="loading">
                      <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
                    </ng-container>

                    <ng-container matColumnDef="noData">
                      <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Search.searchResultsNoData' | translate}}... </th>
                    </ng-container>

                    <tr mat-header-row  [ngClass]="{'tableFilterBgColor':isGeneratedSearch===false}" *matHeaderRowDef="displayColumns; sticky: true"></tr>
                    <tr mat-header-row class="tableFilterBgColor"
                      *matHeaderRowDef="['desFilter', 'itemFilter', 'valueFilter', 'dateFilter']; sticky: true">
                    </tr>
                    <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                    <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':isLoading==false}"></tr>
                    <tr mat-footer-row *matFooterRowDef="['noData']"
                    [ngClass]="{'hide':dataSource!=null && recordsLength != 0}"></tr>

                  </table>
                </div>
                <mat-divider></mat-divider>
                <div class="itemsLabel">
                  <div>
                    Items per page: <input [(ngModel)]="mattablePageSize" matInput type="text" (change)="OnPagesizeChange()">
                  </div>
                  <mat-paginator [pageSize]="mattablePageSize" hidePageSize="true" [length]="recordsLength"></mat-paginator>
                </div>
              </div>
            </div>